import request from '@/utils/request'

export function fetchQrCode() {
  return request({
    url: '/acc/fetch_qr_code',
    method: 'post',
  })
}
export function fetchNewQrCode() {
  return request({
    url: '/acc/fetch_new_qr_code',
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/qrcode.js